module.exports = __webpack_public_path__ + "images/search-97e05b90e843ce7dda055c202b60b195.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/search.svg
// module id = 212
// module chunks = 0